// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Event__item-d11f7b {
  display: inline-flex;
  border-radius: 19px;
  box-sizing: border-box;
  padding: 6px 12px;
  align-items: center;
  word-break: break-word;
  font: var(--font-button);
  letter-spacing: var(--font-spacing-body-1);
  color: var(--addition-50);
  max-width: 328px;
  margin-bottom: 4px;
  background-color: var(--addition-120);
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/Shared/EventsBar/components/Event/Event.styles.m.css"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBAAA;EACA,sBAAA;EACA,wBAAA;EACA,0CAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qCAAA;AACF","sourcesContent":[".item {\n  display: inline-flex;\n  border-radius: 19px;\n  box-sizing: border-box;\n  padding: 6px 12px;\n  align-items: center;\n  word-break: break-word;\n  font: var(--font-button);\n  letter-spacing: var(--font-spacing-body-1);\n  color: var(--addition-50);\n  max-width: 328px;\n  margin-bottom: 4px;\n  background-color: var(--addition-120);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"item": `Event__item-d11f7b`
};
module.exports = ___CSS_LOADER_EXPORT___;
